import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import MyAccountQuery from 'Query/MyAccount.query';
import { fetchQuery } from 'Util/Request';

import MyAccountCompanyAutosuggest from './MyAccountCompanyAutosuggest.component';

/** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/mapStateToProps */
export const mapStateToProps = (/* state */) => ({
});

/** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/mapDispatchToProps */
export const mapDispatchToProps = (/* dispatch */) => ({
});

/** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container */
export class MyAccountCompanyAutosuggestContainer extends PureComponent {
    static propTypes = {
        onSuggestionSelected: PropTypes.func.isRequired,
        zipcode: PropTypes.string.isRequired
    };

    containerFunctions = {
        onChange: this.onChange.bind(this),
        getSuggestions: this.getSuggestions.bind(this),
        getSuggestionValue: this.getSuggestionValue.bind(this),
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested.bind(this),
        onSuggestionsClearRequested: this.onSuggestionsClearRequested.bind(this),
        onSuggestionSelected: this.onSuggestionSelected.bind(this)
    };

    getSuggestionsAbortController = null;

    state = {
        suggestions: [],
        value: '',
        isLoading: false,
        isLoadingSuggestions: false
    };

    // eslint-disable-next-line
    debouncedLoadSuggestions = debounce(this.loadSuggestions, 200);

    containerProps() {
        // const { onSuggestionSelected } = this.props;
        const {
            suggestions, value, isLoading, isLoadingSuggestions
        } = this.state;

        return {
            suggestions,
            // onSuggestionSelected,
            value,
            isLoading,
            isLoadingSuggestions
        };
    }

    onChange(event, { newValue }) {
        this.setState({
            value: newValue
        });
    }

    getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    async getSuggestions(keyword) {
        const { zipcode } = this.props;

        if (this.getSuggestionsAbortController) {
            this.getSuggestionsAbortController.abort();
        }
        this.getSuggestionsAbortController = new AbortController();

        const options = {
            postcode: zipcode,
            name: keyword
        };

        return fetchQuery(
            MyAccountQuery.getCompanySuggestions(options), this.getSuggestionsAbortController.signal
        ).then(
            /** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/getSuggestions/then/catch/fetchQuery/then */
            (res) => {
                this.getSuggestionsAbortController = null;
                return res.searchEnterprise;
            }
        ).catch(
            /** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/getSuggestions/then/catch */
            (err) => {
                if (!(err instanceof DOMException && err.name === 'AbortError')) {
                    throw err;
                }

                return [];
            }
        );
    }

    loadSuggestions(value) {
        this.setState({ isLoadingSuggestions: true });

        this.getSuggestions(value).then(
            /** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/loadSuggestions/then/catch/getSuggestions/then */
            (suggestions) => {
                this.setState({
                    suggestions: suggestions ?? [],
                    isLoadingSuggestions: false
                });
            }
        ).catch(
            /** @namespace  PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/loadSuggestions/then/catch   */
            () => {
                this.setState({ isLoadingSuggestions: false });
                return [];
            }
        );
    }

    async getEnterpriseDetails(siren) {
        this.setState({ isLoading: true });

        return fetchQuery(MyAccountQuery.getEnterpriseDetails(
            siren
        )).then(
            /** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/getEnterpriseDetails/then/catch/fetchQuery/then */
            ({ getEnterpriseDetails: companyDetails }) => {
                this.setState({ isLoading: false });
                return companyDetails;
            }
        ).catch(
            /** @namespace PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/getEnterpriseDetails/then/catch */
            () => {
                this.setState({ isLoading: false });
                return false;
            }
        );
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested({ value }) {
        this.debouncedLoadSuggestions(value);
    }

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }

    onSuggestionSelected(event, { suggestion }) {
        const { onSuggestionSelected } = this.props;
        const { siren } = suggestion;

        if (siren) {
            this.getEnterpriseDetails(siren)
                .then(
                    /** @namespace  PeggysagePwa/Component/MyAccountCompanyAutosuggest/Container/MyAccountCompanyAutosuggestContainer/onSuggestionSelected/getEnterpriseDetails/then */
                    (companyDetails) => {
                        if (companyDetails) {
                            onSuggestionSelected(event, { suggestion: companyDetails });
                        } else {
                            onSuggestionSelected(event, { suggestion });
                        }
                    }
                );
        } else {
            onSuggestionSelected(event, { suggestion });
        }
    }

    render() {
        return (
            <MyAccountCompanyAutosuggest
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountCompanyAutosuggestContainer);
